import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import axios from 'axios';
import update from 'immutability-helper';
// import jump from 'jump.js';
import { TimelineMax } from 'gsap/all';
import CartList from './CartList';

class MiniCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      cart: {}
    };
    this.toggle = this.toggle.bind(this);
    this.updateLineQuantity = this.updateLineQuantity.bind(this);
  }

  componentDidMount() {
    this.container = ReactDOM.findDOMNode(this);
    this.setupAnimations();
    this.updateCartInfo();

    document.body.addEventListener('cart.productAdded', (ev) => {
      // console.log('Minicart received cart.productAdding event');
      this.updateCartInfo(ev);
    });

    // When minicart open and users clicks outside it, close the dialog
    document.addEventListener('click', (ev) => {
      const isClickInside = this.container.contains(event.target);
      if (!isClickInside && this.state.open) {
        this.close();
      }
    });

    // Check if we have a logged in customer
    const dataset = this.container.parentNode.dataset;
    this.setState({
      customerName: dataset.loggedIn,
      shouldScroll: dataset.shouldscroll
    });

    window.addEventListener('resize', (ev) => {
      // close causes issues when adding to cart on mobile
      // this.close();
      this.calculateCoordinates();
    });
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.open !== this.state.open && this.state.open === true) {
  //     if (this.state.shouldScroll) {
  //       jump(document.querySelector('.Header'), {
  //         duration: 600,
  //         offset: -200
  //       });
  //     }
  //   }
  // }

  setupAnimations() {
    const container = this.container;
    const dropdown = container.querySelector('.MiniCart__dropdown');
    const dropdownSections = container.querySelector('.MiniCart__contents');
    // const buttonDeco = container.querySelector('.MiniCart__toggle .background');
    // console.log(this.container);
    this.toggleBtn = this.container;
    this.dropdown = dropdown;
    this.DropdownIcon = dropdown.querySelector('.arrow');

    this.tl = new TimelineMax({});
    this.tl.set(dropdown, { display: 'block', immediateRender: false });
    this.tl.from(dropdown, 0.25, {
      y: 100,
      opacity: 0,
      ease: Back.easeOut.config(1.7)
    });
    this.tl.staggerFrom(
      dropdownSections,
      0.3,
      {
        y: '10%',
        opacity: 0,
        ease: Back.easeOut.config(1.3)
      },
      0.1
    );
    this.tl.pause();
  }

  toggle(ev) {
    ev.preventDefault();
    if (this.state.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.calculateCoordinates();
    this.setState({ open: true }, () => {
      this.tl.play();
    });
    dataLayer.push({'event': 'optimize.activate'});
  }

  close() {
    this.setState({ open: false }, () => {
      this.tl.reverse();
    });
  }

  updateCartInfo(ev) {
    // console.log('Minicart: Initiate the Cart update process', ev);
    // Get Cart Info
    axios
      .get('/cart.js', { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        const newState = update(this.state.cart, {
          $set: response.data
        });

        this.setState({ cart: newState }, () => {
          // When reacting to add to cart events, broadcast the update
          // (excludes the initial state update)
          if (ev) {
            const minicartUpdated = new CustomEvent('cart.cartUpdated', {
              detail: response.data
            });
            document.body.dispatchEvent(minicartUpdated);
            this.open();
          }
        });
        return true;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateLineQuantity(productVariantId, newQuantity) {
    axios
      .post('/cart/update.js', {
        updates: { [productVariantId]: newQuantity }
      })
      .then((response) => {
        const newState = update(this.state.cart, {
          $set: response.data
        });
        this.setState({ cart: newState });
        // console.log('Cart has updated with the data: ', newState);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  renderUserAccountOptions() {
    if (this.state.customerName !== '') {
      return (
        <div className="Nav Nav--vertical">
          <div className="header">Hello, {this.state.customerName}!</div>
          <a href="/account" className="Nav__item">
            My Account
          </a>
          <a href="/account/logout" className="Nav__item" data-no-swup>
            Sign Out
          </a>
        </div>
      );
    } else {
      return (
        <div className="Nav Nav--vertical">
          <a href="/account/login" className="Nav__item">
            Sign In
          </a>
          <a href="/account/register" className="Nav__item">
            Create Account
          </a>
        </div>
      );
    }
  }

  calculateCoordinates() {
    let buttonCoords = this.toggleBtn.getBoundingClientRect();
    let newPosition = buttonCoords.left;
    // this.dropdown.style.top = `${buttonCoords.bottom + 16}px`;
    this.DropdownIcon.style.left = `${newPosition}px`;
  }

  render() {
    let cartIcon;
    if (this.state.cart.item_count > 0) {
      cartIcon = 'cartFull';
    } else {
      cartIcon = 'cartEmpty';
    }

    return (
      <div className="MiniCartButton">
        <a href="/cart" className="Button Button--noLayout MiniCart__toggle" onClick={this.toggle}>
          <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" className="icon">
            <g transform="translate(98 51)" fill="none" fillRule="evenodd">
              <path
                d="M152 0c-45.243.05-81.907 36.831-81.957 82.217v17.438H21.814c-4.395-.001-8.016 3.462-8.225 7.867L.01 391.346a8.277 8.277 0 0 0 2.266 6.093A8.223 8.223 0 0 0 8.234 400h287.532a8.223 8.223 0 0 0 5.96-2.56 8.277 8.277 0 0 0 2.265-6.094l-13.58-283.824c-.209-4.405-3.83-7.868-8.225-7.867h-48.229V82.217C233.907 36.831 197.243.051 152 0zM86.511 82.217c.037-36.257 29.346-65.63 65.489-65.63s65.452 29.373 65.488 65.63v17.438H86.511V82.217zm187.826 33.959l12.79 267.303H16.873l12.788-267.303h40.38v64.806c0 4.562 3.687 8.26 8.235 8.26s8.234-3.698 8.234-8.26v-64.806H217.49v64.806c0 4.562 3.686 8.26 8.234 8.26s8.234-3.698 8.234-8.26v-64.806h40.38z"
                fill="currentColor"
                fillRule="nonzero"
              />
              {this.state.cart.item_count > 0 && <circle id="cartHasContents" fill="#BB7064" cx="152.5" cy="273.5" r="38.5" />}
            </g>
          </svg>
        </a>
        <div className="MiniCart__dropdown">
          <span className="arrow" />
          <div className="MiniCart__contents">
            <CartList cart={this.state.cart} products={this.state.cart.items} updateLineQuantity={this.updateLineQuantity} />
            {this.renderUserAccountOptions()}
          </div>
        </div>
      </div>
    );
  }
}

// const init = (el) => {
//   const element = <MiniCart />;
//   ReactDOM.render(element, el);
// };

// export default init;

export default component((node, ctx) => {
  const element = <MiniCart appstate={ctx} parentNode={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function() {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
